var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SignupOptions',_vm._b({class:_vm.className},'SignupOptions',_vm.$props,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }